import { useSnapshot } from 'valtio'
import cn from 'classnames'
import type { MouseEventHandler, ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface CancelButtonProps {
  disabled?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  text: string
}
export function CancelButton ({ onClick, text, disabled = false }: CancelButtonProps): ReactElement {
  const { siteTheme } = useSnapshot(proxyGlobalAuth)
  return (
    <button
      type="button"
      className={
        cn(
          siteTheme.buttonColors.secondaryClasses,
          'w-36 flex justify-center items-center py-2 px-4 rounded-md text-sm font-medium cursor-pointer focus:outline-none'
        )
      }
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </button>
  )
}
